<template>
    <main id="mainCtrl">
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" v-cloak>
                <li
                    :class="{'active': defaultFilter.type === 'new'}"
                    @click.stop.prevent="load('new')"
                    id="tabNew"
                ><a href="#">Новые</a>
                </li>
                <li
                    :class="{'active': defaultFilter.type === 'approved'}"
                    @click.stop.prevent="load('approved')"
                    id="tabApproved"
                ><a href="#">Опубликованные</a>
                </li>
                <li
                    :class="{'active': defaultFilter.type === 'rejected'}"
                    @click.stop.prevent="load('rejected')"
                    id="tabRejected"
                ><a href="#">Отклонённые</a>
                </li>
            </ul>
        </div>
        <v-table id="table" request-uri="answers" :lazycount="true" pagesize="10" ref="table" :default-filter="defaultFilter" @updated="setAnswersHeight">
            <template v-slot:header>
                <v-tr>
                    <v-th name="doctorOrUserName">Имя врача или пациента</v-th>
                    <v-th name="speciality">Специализация</v-th>
                    <v-th name="answerContent">Текст ответа</v-th>
                    <v-th name="questionUrl">URL вопроса</v-th>
                    <v-th name="questionIsPayable">Вид</v-th>
                </v-tr>
                <v-tr>
                    <v-th name="doctorOrUserName" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="speciality" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[{value: '', text: '\u00a0'}, ...specs]"/>
                    </v-th>
                    <v-th name="answerContent" :debounce="true" v-slot="{filter}"><v-input v-model="filter.value" /></v-th>
                    <v-th name="questionUrl" v-slot="{filter}"><v-input v-model="filter.value" /></v-th>
                    <v-th name="questionIsPayable" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: 'PAYABLE', text: 'Платный' },
                                { value: 'FREE', text: 'Бесплатный' },
                                { value: 'INDIVIDUAL', text: 'Индивидуальный' },
                                { value: 'INDIVIDUAL_AND_PAYABLE', text: 'Индивидуальный + платный' },
                            ]"
                        ></v-select>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr>
                    <v-td colspan="5">
                        <Answer :answer="item" @updatePlease="updateTable" :key="item.id"/>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
    import Answer from "./components/Answer"
    import NewPublishedUnpublishedSwitcher from "@mixins/NewPublishedUnpublishedSwitcher"
    export default {
        props: {specs: Array},
        components: { Answer },
        mixins: [NewPublishedUnpublishedSwitcher],
        methods: {
            updateTable() {
                this.$refs.table.update()
            },
            setAnswersHeight() {
                setTimeout(() => {
                    document.querySelectorAll('.answer-text').forEach(el => {
                        el.dispatchEvent(new Event('blur', { bubbles: true }));
                        el.style.height = '45px';
                        el.style.height = 5 + el.scrollHeight + 'px';
                    })
                }, 100)
            }
        },
    }
</script>
